<template>
</template>
<script setup lang="ts">
import axios from 'axios'
import { useRouter } from 'vue-router'
import { getCurrentInstance } from 'vue';
// 导入项目中存储工具和常量（关键！）
import ls from '@/utils/storage'; // 假设ls的路径是这个，根据实际项目调整
import { ACCESS_TOKEN } from '/src/store/mutation-types'; // 导入ACCESS_TOKEN常量
import f,{sysInfo} from '/src/utils/f.ts';



const internalInstance = getCurrentInstance();
const router = useRouter();
type SqlDbType = 
  | 'Char'
  | 'DateTime'
  | 'NChar'
  | 'NText'
  | 'NVarChar'
  | 'Int'
  | 'BigInt'
  | 'Money'
  | 'Float'
  | 'Decimal'
  | 'Text'
  | 'VarChar'
  | 'Date'
  | 'Time'
  | 'DateTime2'
  | 'Bit'
  | string;

// 定义单个 SQL 参数接口（对应 C# 的 SqlParameter）
interface SqlParameter {
  ParameterName: string;
  SqlDbType: SqlDbType;
  Value: any;
}


/**
 * 辅助函数：SQL字符串转义（单引号转双引号，避免注入）
 * @param str - 待转义字符串
 * @returns 转义后的字符串
 */
const quotedStr = (str?: string | null): string => {
  if (!str) return "''";
  return `'${str.replace(/'/g, "''")}'`;
};

/**
 * 辅助函数：判断值是否为空（对应 C# 的 DBNull、null、空字符串）
 * @param value - 待判断值
 * @returns 是否为空
 */
const isNullValue = (value: any): boolean => {
  return value === null || value === undefined ||  value === '';
};

/**
 * 辅助函数：格式化日期为 yyyy-MM-dd HH:mm:ss
 * @param date - 待格式化日期
 * @returns 格式化后的日期字符串
 */
const formatDateTime = (date: Date): string => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
};

/**
 * 辅助函数：格式化日期为 yyyy-MM-dd
 * @param date - 待格式化日期
 * @returns 格式化后的日期字符串
 */
const formatDate = (date: Date): string => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
// 正确获取Token的函数
const getToken = () => {
  try {
    // 从项目的存储工具中获取Token（使用ACCESS_TOKEN常量作为键名）
    const token = ls.get(ACCESS_TOKEN);
    // console.log('从ls获取Token:', token ? '存在' : '不存在');
    return token || '';
  } catch (error) {
    console.error('获取Token失败:', error);
    return '';
  }
}

// dm.vue 中的 data 方法（默认 GET，新增 isPost 参数）
async function data(api, params, isPost = false) {
  try {
    const token = getToken();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    let response;
    if (isPost) {
      // POST 模式：参数放请求体，路径拼 post 后缀
      headers['Content-Type'] = 'application/json';
      const requestUrl = `${api}post`;
      response = await axios.post(requestUrl, params, { headers });
    } else {
      // 默认 GET 模式：参数拼 URL（兼容原有所有调用）
      response = await axios.get(api, { params, headers });
    }

    if (response.data.message === 'Token鉴权失败！') {
      console.error('Token鉴权失败，即将跳转到登录页');
      ls.remove(ACCESS_TOKEN);
      router.push('/user/login');
      return null;
    }

    return response.data;
  } catch (error) {
    console.error('请求失败:', error);
    return null;
  }
}
// async function data(api, params) {
//   try {
//     const token = getToken();
//     // console.log('准备发起请求，当前Token:', token);
    
//     const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    
//     const response = await axios.get(api, {
//       params: { ...params },
//       headers
//     })

//     if (response.data.message === 'Token鉴权失败！') {
//       console.error('Token鉴权失败，即将跳转到登录页');
//       ls.remove(ACCESS_TOKEN);
//       router.push('/user/login');
//       return null;
//     }

//     return response.data;
//   } catch (error) {
//     console.error('请求失败:', error);
//     return null;
//   }
// }

// async function exec(api, params) {
//   try {
//     const token = getToken();
//     const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    
//     await axios.get(api, {
//       params: { ...params },
//       headers
//     })
//     return true;
//   } catch (error) {
//     console.error('执行请求失败:', error);
//     return false;
//   }
// }


// dm.vue 中的 exec 方法（默认 GET，新增 isPost 参数）
async function exec(api, params, isPost = false) {
  try {
    const token = getToken();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    let response;
    if (isPost) {
      // POST 模式：参数放请求体，路径拼 post 后缀
      headers['Content-Type'] = 'application/json';
      const requestUrl = `${api}post`;
      response = await axios.post(requestUrl, params, { headers });
    } else {
      // 默认 GET 模式：参数拼 URL（兼容原有所有调用）
      response = await axios.get(api, { params, headers });
    }

    // 适配后端返回格式：success 或 status=0 均视为成功
    return response.data?.success || response.data?.status === 0 || response.data?.code === 200;
  } catch (error) {
    console.error('执行请求失败:', error);
    return false;
  }
}

// 极简版 getValueFromSql（适配你的opends调用逻辑）getValueFromSql
async function getValueFromSql(sql, dbName = 'SYS', DefValue = '') {
  try {
    // 直接调用你现有的opends方法执行SQL
    const result = await opends(sql, dbName);
    
    // 1. 校验返回结果（和你导出逻辑的校验对齐）
    if (!result || result.status !== 0 || !result.data?.list || !Array.isArray(result.data.list)) {
      return DefValue.toString(); // 无数据返回默认值
    }
    
    const rawData = result.data.list;
    // 2. 取第一行第一列的值（对齐C# dt.Rows[0][0]）
    if (rawData.length === 0) {
      return DefValue.toString();
    }
    const firstRow = rawData[0];
    const firstColumnKey = Object.keys(firstRow)[0]; // 第一列的字段名
    const firstColumnValue = firstRow[firstColumnKey];
    
    // 3. 返回值（有值则转字符串，无值则返回默认值）
    return firstColumnValue ? firstColumnValue.toString() : DefValue.toString();

  } catch (error) {
    // 异常场景返回默认值
    console.error('getValueFromSql执行失败:', error);
    return DefValue.toString();
  }
};

// 封装从接口获取数据的方法（对应后端dm.OpenDs）
async function opends(sql, dbName) {
  try {
    // 1. 获取Token（沿用现有鉴权逻辑）
    const token = getToken();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    // 2. 构造请求参数（与后端存储过程调用格式对齐）
    const params = {
      sql: sql,         // 存储过程SQL（如"Exec P_GetTargetDepTree 'user123'"）
      dbname: dbName    // 数据库名称（如"mr"对应后端dm.dbs.mr）
    };

    // 3. 调用后端接口（假设接口路径与OpenDs功能匹配）
    const response = await axios.get('/api/comm/opends/', {
      params: params,
      headers: headers
    });

    // 4. 处理Token失效（复用现有鉴权失败逻辑）
    if (response.data.message === 'Token鉴权失败！') {
      console.error('Token鉴权失败，即将跳转到登录页');
      ls.remove(ACCESS_TOKEN);
      router.push('/user/login');
      return null;
    }

    // 5. 数据格式转换（适配后端返回的数据集结构）
    return response.data // 返回获取到的数据

  } catch (error) {
    // 7. 错误处理（网络异常、接口错误等）
    console.error('openDS请求失败:', error);
    // 可添加错误提示（如toastr）
    // toastr.error('数据获取失败，请重试');
    return null;
  }
}

/**
 * 执行多行语句并启用事务（一条失败所有失败），对应C#的ExcuteP_Try
 * @param cmdtext - 待执行的多行SQL语句文本
 * @param dbName - 数据库名称（默认空字符串）
 * @returns boolean - 执行成功返回true，失败返回false
 */
 async function excutep_try(cmdtext: string, dbName: string = ""): Promise<boolean> {
  // 1. 拼接SQL（对应C#：sSQL = "P_Try " + QuotedStr(cmdtext)）
  const quotedCmd = quotedStr(cmdtext); // 复用你已有的quotedStr转义函数
  const sSQL = `P_Try ${quotedCmd}`;

  try {
    // 2. 调用opends执行SQL（对应C#的dm.openDs）
    const TempDS = await opends(sSQL, dbName);

    // 3. 解析返回结果（对应C#遍历TempDS.Rows取Result字段）
    if (TempDS?.data?.list?.length > 0) {
      const dr = TempDS.data.list[0]; // 取第一行数据
      return dr["Result"]?.toString() === "1";
    }
    // 无结果集则返回false
    return false;

  } catch (e: any) {
    // 4. 异常处理（对齐C#的日志/提示逻辑）
    const errorMsg = e.message || "未知错误";
    console.error(`ExcuteP_Try执行失败: ${errorMsg}`);
    
    // 写入错误日志（复用你项目的日志工具f）
    if (typeof f?.writeErroLog === 'function') {
      console.log(`USE \t${dbName}`);
      console.log(sSQL);
      console.log(errorMsg);
    }

    // 前端弹窗提示（替换为你项目的提示组件，如message/Modal）
    if (typeof window !== 'undefined') {
      console.log(`${errorMsg}\r\n${sSQL}`); // 简易版，可替换为antd的message.error/Modal.error
    }

    return false;
  }
}

/**
 * 执行SQL查询，判断是否存在记录（对应新的C#版本）
 * @param sSQL - 待执行的SQL查询语句
 * @param dbName - 数据库名称（默认值："SYS"）
 * @returns boolean - 存在记录返回true，否则返回false
 */
 async function existrecord(sSQL: string, dbName: string = ""): Promise<boolean> {
  // 对应C#：dbName为空则默认赋值"SYS"
  const finalDbName = dbName || "SYS";
  
  try {
    // 调用已有的opends方法执行SQL（对应C#的dm.openDs）
    const ds2 = await opends(sSQL, finalDbName);
    
    // 对应C#的ds2.Rows.Count > 0：判断返回结果是否有数据
    // 适配后端返回格式（根据你的opends实际返回结构调整，以下是通用版）
    const hasRecord = ds2?.data?.list?.length > 0 || ds2?.list?.length > 0;
    return hasRecord;

  } catch (sqlex) {
    // 对应C#的catch逻辑：捕获异常返回false
    console.error(`ExistRecord执行失败: ${sqlex.message}`);
    return false;
  }
}

// 2. 执行 SQL（对应原 dm.ExcuteSql）
// async function excuteSql(sqlId, params) {
//   return exec(sqlId, params);
// }
async function excuteSql(sql, dbname) {
  // 1. 构造接口所需参数（仅 sql + dbname）
  const params = {
    sql: sql || '',                // 执行的SQL语句，为空则传空字符串
    dbname: dbname || 'SYS'        // 数据库名，兜底默认值 SYS
  };
  
  try {
    const token = getToken();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    // 2. 直接调用后端独立的 /api/comm/excutesql 接口（GET 请求）
    const response = await axios.get('/api/comm/excutesql', { params, headers });

    // 3. 处理 Token 鉴权失败（后端明确返回该提示时，跳转登录页）
    if (response.data?.message === 'Token鉴权失败！') {
      console.error('Token鉴权失败，即将跳转到登录页');
      ls.remove(ACCESS_TOKEN);
      router.push('/user/login');
      return false;
    }

    // 4. 适配后端返回格式：success 或 status=0 均视为成功
    return response.data?.success || response.data?.status === 0 || response.data?.code === 200;
  } catch (error) {
    console.error('执行SQL请求失败:', error);
    return false;
  }  
}

async function getValue(api, params) {
  try {
    const token = getToken();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    
    const response = await axios.get(api, {
      params: { ...params },
      headers
    })

    if (response.data.data && response.data.data.list && response.data.data.list.length > 0) {
      const data = response.data.data.list[0];
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          return data[key];
        }
      }
    }

    return null;
  } catch (error) {
    console.error('获取值失败:', error);
    return null;
  }
}

/**
 * 替换SQL中的参数（对应 C# 的 repalceSqlPara 方法）
 * @param sqlText - 待替换的SQL文本
 * @param parameter - 参数集合（对应 C# 的 SqlParameterCollection）
 * @param ReplaceConstValue - 是否替换系统常量参数（默认true）
 * @returns 替换后的SQL文本
 */
const replaceSqlPara = (
  sqlText: string | null | undefined,
  parameter?: SqlParameter[] | null,
  ReplaceConstValue: boolean = true
): string => {
  let text = sqlText || '';
  // const sysInfo = getSysInfo();

  // 1. 替换SQL参数（对应原参数循环处理逻辑）
  if (Array.isArray(parameter) && parameter.length > 0) {
    parameter.forEach((sqlParameter) => {
      const { ParameterName, SqlDbType, Value } = sqlParameter;
      const placeholder = `{${ParameterName}}`;
      let replaceValue = 'NULL';

      // 处理空值
      if (isNullValue(Value)) {
        text = text.replace(new RegExp(placeholder, 'g'), replaceValue);
        return;
      }

      // 统一转为小写处理，避免大小写敏感
      const dbType = (SqlDbType || '').toLowerCase() as Lowercase<SqlDbType>;

      // 根据参数类型处理替换值
      switch (dbType) {
        // Char类型
        case 'char':
          replaceValue = quotedStr(Value?.toString());
          break;

        // DateTime类型
        case 'datetime':
          try {
            const date = new Date(Value);
            if (!isNaN(date.getTime())) {
              replaceValue = quotedStr(formatDateTime(date));
            }
          } catch (e) {
            console.error(`[replaceSqlPara] 参数${ParameterName}日期格式错误:`, e);
            replaceValue = 'NULL';
          }
          break;

        // Unicode字符串类型
        case 'nchar':
        case 'ntext':
        case 'nvarchar':
          replaceValue = `N${quotedStr(Value?.toString())}`;
          break;

        // 数值类型
        case 'int':
        case 'bigint':
        case 'money':
        case 'float':
        case 'decimal':
          const numValue = Number(Value);
          replaceValue = isNaN(numValue) ? 'NULL' : numValue.toString();
          break;

        // 布尔类型
        case 'bit':
          replaceValue = Value ? '1' : '0';
          break;

        // 文本类型
        case 'text':
        case 'varchar':
          replaceValue = quotedStr(Value?.toString());
          break;

        // Date类型（仅日期）
        case 'date':
          try {
            const date = new Date(Value);
            if (!isNaN(date.getTime())) {
              replaceValue = quotedStr(formatDate(date));
            }
          } catch (e) {
            console.error(`[replaceSqlPara] 参数${ParameterName}日期格式错误:`, e);
            replaceValue = 'NULL';
          }
          break;

        // Time类型
        case 'time':
          replaceValue = quotedStr(Value?.toString());
          break;

        // DateTime2类型
        case 'datetime2':
          try {
            const date = new Date(Value);
            // 排除默认时间（1970-01-01）
            if (!isNaN(date.getTime()) && !(date.getFullYear() === 1970 && date.getMonth() === 0 && date.getDate() === 1)) {
              replaceValue = quotedStr(formatDateTime(date));
            }
          } catch (e) {
            console.error(`[replaceSqlPara] 参数${ParameterName}日期格式错误:`, e);
            replaceValue = 'NULL';
          }
          break;

        // 其他类型默认处理
        default:
          replaceValue = quotedStr(Value?.toString());
          break;
      }

      // 替换所有匹配的占位符（全局替换）
      text = text.replace(new RegExp(placeholder, 'g'), replaceValue);
    });
  }

  // 2. 替换系统常量参数（对应原 ReplaceConstValue 逻辑）
  if (ReplaceConstValue) {
  text = text
    .replace(/{USERID}/g, quotedStr(sysInfo.UserID))
    .replace(/{USERNAME}/g, quotedStr(sysInfo.UserName))
    // 修复：先判断是否存在，再调用 toString()，否则用空字符串
    .replace(/{USERROLE}/g, sysInfo.UserRoleGroupID !== undefined ? sysInfo.UserRoleGroupID.toString() : '')
    .replace(/{HOSTNAME}/g, quotedStr(sysInfo.HostName))
    .replace(/{HOSTIP}/g, quotedStr(sysInfo.HostIP));
}

  return text;
};

defineExpose({
  data,
  exec,
  getValue,
  replaceSqlPara,
  excuteSql,
  opends,
  existrecord,
  excutep_try,
  getValueFromSql,
})
</script>
